import React, { useState } from 'react'

import CopyIcon from '@src/components/icons/Copy'
import { walletLogger } from '@src/utils/logger'

type CopyToClipboardProps = {
    textToCopy: string
    anchorId: string
    textType?: 'Address' | 'Referral Code'
    fitContent?: boolean
}

const CopyToClipboard: React.FC<CopyToClipboardProps> = ({
    textToCopy,
    anchorId,
    textType = 'Address',
    fitContent = true,
}) => {
    const [tooltipText, setTooltipText] = useState(`Copy ${textType}`)

    const handleCopy = () => {
        // Check if navigator.clipboard is available
        if (window.navigator.clipboard) {
            window.navigator.clipboard
                .writeText(textToCopy)
                .then(() => {
                    showCopiedMessage()
                })
                .catch(() => {
                    walletLogger.error('Browser does not support clipboard')
                })
        }
    }

    const showCopiedMessage = () => {
        setTooltipText(`${textType} Copied!`)
        setTimeout(() => {
            setTooltipText(`Copy ${textType}`)
        }, 2000) // Reset after 2 seconds
    }

    return (
        <div
            className={`relative inline-block flex h-full w-full ${fitContent ? 'basis-[fit-content]' : ''} cursor-pointer rounded-lg bg-mach-gray hover:opacity-80`}
        >
            <span id={anchorId} data-tooltip-content={tooltipText} data-tooltip-place='left' className='m-auto'>
                <CopyIcon onClick={handleCopy} />
            </span>
        </div>
    )
}

export default CopyToClipboard
